import React from 'react'
import ReactDOM from 'react-dom'
import videojs from 'video.js'
import { Icon } from 'aria-viewer/common/components/Icon'

const vjsComponent = videojs.getComponent('Component')

export default class SettingMenuButton extends vjsComponent {
    constructor(player, options) {
        super(player, options)
        this.state = {
            classes: options.classes,
            clickCallback: options.clickCallback,
            displayMenu: options.displayMenu || false,
        }
        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this)

        /* When player is ready, call method to mount React component */
        player.ready(() => {
            this.mount()
        })

        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el())
        })
    }

    mount() {
        const { clickCallback } = this.state
        ReactDOM.render(
            <div>
                <button onClick={clickCallback}>
                    <Icon>{'settings'}</Icon>
                </button>
            </div>,
            this.el()
        )
    }
}
